import styles from "./InputField.module.scss";

const RadioGroup = ({
  register,
  name,
  validation,
  errors,
  label,
  elements,
  isStatic,
  watch,
  selectedValue,
  setSelectedValue,
}) => {
  const selectedText = elements.find((el) => {
    return String(el.value) === String(watch(name));
  });
  const handleChange = (e) => {
    //型を保持するためstringで比較してelementsから取り直す
    const elm = elements.find((el) => {
      return e.target.value === String(el.value);
    });
    if (setSelectedValue) setSelectedValue(elm.value);
  };

  return (
    <div className={styles.field}>
      <label className={styles.field__label}>{label}</label>
      <div
        className={`${styles.field__input}  ${isStatic ? "d-none" : ""} ${
          errors[name] ? "is-invalid" : ""
        }`}
      >
        {elements.map((el) => (
          <label className={styles.field__element} key={el.value}>
            <input
              type="radio"
              className="form-check-input"
              name={name}
              value={String(el.value)}
              checked={selectedValue === el.value}
              defaultChecked={el.defaultChecked}
              {...register(name, {
                validation,
                onChange: handleChange,
              })}
            ></input>
            {el.label}
          </label>
        ))}
      </div>
      {isStatic && (
        <div className={styles.field__input}>{selectedText?.label}</div>
      )}
      <p className={`invalid-feedback ${styles.field__msg}`}>
        {errors[name] ? errors[name].message : ""}
      </p>
    </div>
  );
};
export default RadioGroup;
